module.exports = __webpack_public_path__ + "static/phone-index-c7dc53967fc0cf094e6c24158c7ddb8f.png";